import { BackgroundColors, SecondaryColors, TextColors } from '@/utils/constants';
import { whenTheme } from '@/utils/theme';
import { makeStyles } from '@material-ui/core/styles';

export const useTabbedCardStyles = makeStyles(
  (muiTheme) => ({
    root: {
      position: 'relative',
      '& div[data-stuck]': {
        boxShadow:
          'rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px !important',
      },
    },
    tabsWrapper: ({ theme }: any) => ({
      backgroundColor: whenTheme(
        theme,
        () => BackgroundColors.light,
        () => BackgroundColors.dark,
      ),
      boxShadow: `-1px 12px 15px 0px rgba(${whenTheme(
        theme,
        () => '229,229,229',
        () => '23,30,38',
      )},${whenTheme(
        theme,
        () => '1',
        () => '0.5',
      )})`,
      position: 'relative',
    }),
    tabPanelsWrapper: ({ theme }: any) => ({
      backgroundColor: whenTheme(
        theme,
        () => BackgroundColors.light,
        () => BackgroundColors.dark,
      ),
      padding: muiTheme.spacing(7, 0, 7, 0),
    }),
    tabs: {
      '&.MuiTabs-root': {
        position: 'relative',
        display: 'inline-flex',
        margin: '0 -2px 0px -32px',
        width: 'calc(100% + 64px)',
        minHeight: '70px',
        '& .MuiTabs-flexContainer': {
          height: '100%',
        },
        [muiTheme.breakpoints.up('md')]: {
          width: '100%',
          margin: 'auto',
        },
        '& .MuiTabScrollButton-root': {
          color: SecondaryColors.dark,
        },
        '& .MuiTabs-scroller': {
          [muiTheme.breakpoints.up('md')]: {
            display: 'flex',
            justifyContent: 'center',
          },
        },
      },
      [muiTheme.breakpoints.up('md')]: {
        margin: '0',
        minHeight: '70px',
        maxWidth: '100%',
        width: '100%',

        '& .MuiTabs-flexContainer': {
          position: 'relative',
          width: '100%',
          height: '100%',
          justifyContent: 'space-evenly',
        },
      },
    },
    tab: ({ theme }: any) => ({
      backgroundColor: whenTheme(
        theme,
        () => BackgroundColors.light,
        () => BackgroundColors.dark,
      ),
      display: 'flex',
      alignItems: 'center',
      '&.MuiTab-root': {
        [muiTheme.breakpoints.up('md')]: {
          minWidth: '160px',
        },
      },
      '& h3': {
        fontWeight: '600',
        color: whenTheme(
          theme,
          () => TextColors.dark,
          () => TextColors.light,
        ),
      },
    }),
  }),
  { name: 'TabbedCardStyles' },
);
